import { z } from 'zod';

export const TenantSchema = z.object({
  name: z.string().min(1, { message: 'error_field_required' }).max(255, {
    message: `error.field_max_lengh_255`,
  }),
});

export type FormTenantSchemaType = z.infer<typeof TenantSchema>;

export interface TenantSchemaType extends FormTenantSchemaType {
  id?: number;
}
